import back from "./assets/back.png";
import {useNavigate} from "react-router";
import { useLocation } from "react-router";
import blackBack from './assets/blackBack.svg';

export default function BackButton(){
    const navigate = useNavigate();
    const currentLocation = useLocation();

    const goBack = () => {
        navigate(-1)
    }

    const getBackButton = ()=>{
        switch (currentLocation.pathname){
            case '/login':
                return blackBack;
            default: return back;
        }
    }

    return (
        <div onClick={goBack} style={{width:'40px', height:'40px', position: 'absolute',background:'white', borderRadius:'20px',display:'flex',alignItems:'center',justifyContent:'center',boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)'}}>
            {currentLocation.pathname === '/claim'? null:  <img src={getBackButton()} style={{width: '10px'}} alt=''/> }
        </div>
    )
}